import React from 'react';
import { Building2, Target, ShieldCheck, TrendingUp } from 'lucide-react';
import { aboutContent } from '../data/mock';

const iconMap = {
  0: Building2,
  1: Target,
  2: ShieldCheck,
  3: TrendingUp,
};

const AboutSection = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="inline-block text-cyan-400 text-sm font-semibold tracking-wider uppercase mb-4">
            Who We Are
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            {aboutContent.title}
          </h2>
          <p className="text-lg text-slate-400 leading-relaxed">
            {aboutContent.description}
          </p>
        </div>

        {/* Highlights Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {aboutContent.highlights.map((item, index) => {
            const Icon = iconMap[index];
            return (
              <div
                key={index}
                className="group relative bg-slate-900/50 border border-slate-800 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/5"
              >
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-cyan-500/10 text-cyan-400 mb-6 group-hover:bg-cyan-500/20 transition-colors duration-300">
                  <Icon size={28} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-white mb-3">
                  {item.title}
                </h3>
                <p className="text-slate-400 leading-relaxed">
                  {item.description}
                </p>

                {/* Hover accent */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-cyan-500/5 rounded-full blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
